import { ReactNode } from 'react';
import { Box, Flex, Grid, LogoCoverflex } from '@coverflex-tech/hypernova';
import { css } from './TwoColumnsLayout.css';

interface ITwoColumnsLayoutProps {
  className?: string;
  children: [ReactNode, ReactNode];
  logoSibling?: ReactNode;
}

export const TwoColumnsLayout = ({
  children,
  logoSibling,
}: ITwoColumnsLayoutProps) => {
  return (
    <Grid.Root className={css.host}>
      <Grid.Column span={6} stretchContent>
        <Box
          flexDirection="column"
          justifyContent="center"
          gap="2xl"
          paddingLeft="2xl"
          paddingRight="2xl"
          className={css.column}
        >
          <Flex justifyContent="space-between">
            <LogoCoverflex />
            {logoSibling}
          </Flex>
          {children[0]}
        </Box>
      </Grid.Column>
      <Grid.Column span={6} stretchContent>
        {children[1]}
      </Grid.Column>
    </Grid.Root>
  );
};
